module.exports = __webpack_public_path__ + "img/DQS-box.a2672e3a.svg";